import AssetMetricsReadDto from "../../../../Models/Dashboard/AssetMetricsReadDto";
import { UseQueryResult, useQueries, useQuery } from "react-query";
import AssetImageReadDto from "../../../../Models/Assets/AssetImageReadDto";
import assetsDashboardApiService from "../Utilities/AssetsDashboardApiService";
import AssetsDashboardContainer from "./AssetsDashboardContainer";
import LoadingSpinner from "../../../Shared/Components/LoadingSpinner";
import ErrorCard from "../../../Shared/Components/Cards/ErrorCard";
import { ReactQueryKeys } from "../../../../Constants/ClientRoutingConstants";
import { useResetAssetsDashboardFiltersOnLeave } from "../hooks/useResetAssetsDashboardFiltersOnLeave";

export default function AssetsDashboardPage() {
  useResetAssetsDashboardFiltersOnLeave();

  const assetsMetricsQuery = useQuery<AssetMetricsReadDto[]>(
    [ReactQueryKeys.AllAssetsMetricsQuery], 
    async () => {
      return assetsDashboardApiService.getAllAssetsMetrics();
    },
  );

  // Second query that depends on the first one
  const imagesQueries = useQueries(
    assetsMetricsQuery.data?.map(asset => ({
      queryKey: [ReactQueryKeys.AssetImageQuery, asset.imageId],
      queryFn: () => assetsDashboardApiService.getAssetImage(asset.imageId),
      enabled: !!asset.imageId && !!assetsMetricsQuery.data
    })) ?? []
  ) as UseQueryResult<AssetImageReadDto>[];

  const handleRefresh = async () => {
    // Only refetch the assets metrics, images will update automatically
    await assetsMetricsQuery.refetch();
  };

  // Only show loading spinner on initial load. A failed image must NOT blank the whole
  // dashboard — those cards just render without an image (see the tile/table views).
  if(
    assetsMetricsQuery.isLoading ||
    imagesQueries.some(query => query.isLoading)
  ) {
    return <LoadingSpinner />;
  } else if(assetsMetricsQuery.isError) {
    return <ErrorCard />;
  }

  return (
    <AssetsDashboardContainer
      assetsMetricsData={assetsMetricsQuery.data ?? []}
      imagesQueries={imagesQueries}
      onRefresh={handleRefresh}
      isFetching={assetsMetricsQuery.isFetching}
    />
  );
}